import React, { useState, useEffect } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
} from "react-router-dom";

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

import client from './feathers';

import './App.css';

const contactsService = client.service('v2/contacts');
const usersService = client.service('users');

class ContactInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const contactId = this.props?.match?.params?.contactId || localStorage.getItem('contactId') || '';

    if (!contactId) {
      client.reAuthenticate().then((session) => {
        contactsService.find({
          query: {
            user_id: session.user['_id']
          }
        }).then(res => {
          this.setState({
            onlyfansUsername: res.data[0]['onlyfansUsername'],
            instagramUsername: res.data[0]['instagramUsername'],
            tiktokUsername: res.data[0]['tiktokUsername'],
            paypalUsername: res.data[0]['paypalUsername'],
            twitterUsername: res.data[0]['twitterUsername'],
            githubUsername: res.data[0]['githubUsername'],
            contactId: res.data[0]['_id'],
          });
        }).catch(err => {
          this.setState({
            onlyfansUsername: localStorage.getItem('onlyfansUsername'),
            instagramUsername: localStorage.getItem('instagramUsername'),
            tiktokUsername: localStorage.getItem('tiktokUsername'),
            paypalUsername: localStorage.getItem('paypalUsername'),
            twitterUsername: localStorage.getItem('twitterUsername'),
            githubUsername: localStorage.getItem('githubUsername'),
            contactId: contactId || localStorage.getItem('contactId'),
          });
        });
      });
    } else {
      contactsService.find({ query: { _id: contactId } }).then(res => {
        this.setState({
          onlyfansUsername: res.data[0]['onlyfansUsername'],
          instagramUsername: res.data[0]['instagramUsername'],
          tiktokUsername: res.data[0]['tiktokUsername'],
          paypalUsername: res.data[0]['paypalUsername'],
          twitterUsername: res.data[0]['twitterUsername'],
          githubUsername: res.data[0]['githubUsername'],
          contactId: res.data[0]['_id'],
        });
      }).catch(err => {
        this.setState({
          onlyfansUsername: localStorage.getItem('onlyfansUsername'),
          instagramUsername: localStorage.getItem('instagramUsername'),
          tiktokUsername: localStorage.getItem('tiktokUsername'),
          paypalUsername: localStorage.getItem('paypalUsername'),
          twitterUsername: localStorage.getItem('twitterUsername'),
          githubUsername: localStorage.getItem('githubUsername'),
          contactId: contactId || localStorage.getItem('contactId'),
        });
      });
    }

  }

  showProfile({ username, profile }) {
    if (username && profile === 'onlyfans') {
      window.open(`https://onlyfans.com/${username}`, '_blank');
    } else if (username && profile === 'instagram') {
      window.open(`https://instagram.com/${username}`, '_blank');
    } else if (username && profile === 'tiktok') {
      window.open(`https://tiktok.com/@${username}`, '_blank');
    } else if (username && profile === 'paypal') {
      window.open(`https://paypal.com/paypalme/${username}`, '_blank');
    } else if (username && profile === 'twitter') {
      window.open(`https://twitter.com/${username}`, '_blank');
    } else if (username && profile === 'github') {
      window.open(`https://github.com/${username}`, '_blank');
    }
  }

  copy() {
    navigator.clipboard.writeText(`https://fact-omega.vercel.app/contact/${this.state.contactId}`);
    alert('Copied!');
  }

  render() {
    return (
      <>
        <Container className="p-3">
          <ListGroup className="text-center">
            {
              (this.props.onlyfansUsername || this.state.onlyfansUsername) &&
              <ListGroup.Item action onClick={(e) => this.showProfile({
                username: this.props.onlyfansUsername || this.state.onlyfansUsername,
                profile: 'onlyfans',
              })}>
                {(this.props.onlyfansUsername || this.state.onlyfansUsername) && 'OnlyFans:'} {this.props.onlyfansUsername || this.state.onlyfansUsername || 'OnlyFans username'}
              </ListGroup.Item>
            }

            {
              (this.props.instagramUsername || this.state.instagramUsername) &&
              <ListGroup.Item action onClick={(e) => this.showProfile({
                username: this.props.instagramUsername || this.state.instagramUsername,
                profile: 'instagram',
              })}>
                {(this.props.instagramUsername || this.state.instagramUsername) && 'Instagram:'} {this.props.instagramUsername || this.state.instagramUsername || 'Instagram username'}
              </ListGroup.Item>
            }

            {
              (this.props.tiktokUsername || this.state.tiktokUsername) &&
              <ListGroup.Item action onClick={(e) => this.showProfile({
                username: this.props.tiktokUsername || this.state.tiktokUsername,
                profile: 'tiktok'
              })}>
                {(this.props.tiktokUsername || this.state.tiktokUsername) && 'Tiktok:'} {this.props.tiktokUsername || this.state.tiktokUsername || 'Tiktok username'}
              </ListGroup.Item>
            }

            {
              (this.props.paypalUsername || this.state.paypalUsername) &&
              <ListGroup.Item action onClick={(e) => this.showProfile({
                username: this.props.paypalUsername || this.state.paypalUsername,
                profile: 'paypal'
              })}>
                {(this.props.paypalUsername || this.state.paypalUsername) && 'Paypal:'} {this.props.paypalUsername || this.state.paypalUsername || 'Paypal username'}
              </ListGroup.Item>
            }

            {
              (this.props.twitterUsername || this.state.twitterUsername) &&
              <ListGroup.Item action onClick={(e) => this.showProfile({
                username: this.props.twitterUsername || this.state.twitterUsername,
                profile: 'twitter'
              })}>
                {(this.props.twitterUsername || this.state.twitterUsername) && 'Twitter:'} {this.props.twitterUsername || this.state.twitterUsername || 'Twitter username'}
              </ListGroup.Item>
            }

            {
              (this.props.githubUsername || this.state.githubUsername) &&
              <ListGroup.Item action onClick={(e) => this.showProfile({
                username: this.props.githubUsername || this.state.githubUsername,
                profile: 'github'
              })}>
                {(this.props.githubUsername || this.state.githubUsername) && 'Github:'} {this.props.githubUsername || this.state.githubUsername || 'Github username'}
              </ListGroup.Item>
            }
          </ListGroup>

          <br />

          <InputGroup className="mb-3">
            <InputGroup.Text id="share-url">Share url</InputGroup.Text>
            <FormControl
              aria-label="OnlyFans username"
              aria-describedby="onlyfans-username"
              value={`https://fact-omega.vercel.app/contact/${this.state.contactId}`}
              onChange={(e) => e.preventDefault()}
            />
          </InputGroup>

          <br />

          {
            this.state.contactId &&
            <div className="d-grid gap-2">
              <Button size="lg" onClick={(e) => this.copy(e)}>Copy share url</Button>
            </div>
          }
        </Container>
      </>
    );
  }
}

const Contact = withRouter(ContactInfo);

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: 'Fact',
      onlyfansUsername: localStorage.getItem('onlyfansUsername') || '',
      instagramUsername: localStorage.getItem('instagramUsername') || '',
      tiktokUsername: localStorage.getItem('tiktokUsername') || '',
      paypalUsername: localStorage.getItem('paypalUsername') || '',
      twitterUsername: localStorage.getItem('twitterUsername') || '',
      githubUsername: localStorage.getItem('githubUsername') || '',
    };
  }

  componentDidMount() {
    contactsService.find({ query: { user_id: this.props.users[0]['_id'] } }).then(res => {
      this.setState({
        onlyfansUsername: res.data[0]['onlyfansUsername'],
        instagramUsername: res.data[0]['instagramUsername'],
        tiktokUsername: res.data[0]['tiktokUsername'],
        paypalUsername: res.data[0]['paypalUsername'],
        twitterUsername: res.data[0]['twitterUsername'],
        githubUsername: res.data[0]['githubUsername'],
        contactId: res.data[0]['_id'],
      });
    }).catch(err => {
      this.setState({
        onlyfansUsername: localStorage.getItem('onlyfansUsername') || '',
        instagramUsername: localStorage.getItem('instagramUsername') || '',
        tiktokUsername: localStorage.getItem('tiktokUsername') || '',
        paypalUsername: localStorage.getItem('paypalUsername') || '',
        twitterUsername: localStorage.getItem('twitterUsername') || '',
        githubUsername: localStorage.getItem('githubUseranme') || '',
        contactId: localStorage.getItem('contactId') || '',
      });
    });
  }

  showProfile({ username, profile }) {
    if (username && profile === 'onlyfans') {
      window.open(`https://onlyfans.com/${username}`, '_blank');
    } else if (username && profile === 'instagram') {
      window.open(`https://instagram.com/${username}`, '_blank');
    } else if (username && profile === 'tiktok') {
      window.open(`https://tiktok.com/@${username}`, '_blank');
    } else if (username && profile === 'paypal') {
      window.open(`https://paypal.com/paypalme/${username}`, '_blank');
    } else if (username && profile === 'twitter') {
      window.open(`https://twitter.com/${username}`, '_blank');
    } else if (username && profile === 'github') {
      window.open(`https://github.com/${username}`, '_blank');
    }
  }

  saveChanges() {
    const data = {};
    contactsService.find({
      query: {
        user_id: this.props.users[0]['_id']
      }
    }).then((contacts) => {
      const contactId = contacts.data[0] && contacts.data[0]['_id'];
      Object.keys(this.state).forEach((key) => {
        if (key.indexOf('Username') > -1) {
          localStorage.setItem(key, this.state[key]);
          data[key] = this.state[key];
        }
      });
      if (!contactId) {
        data['user_id'] = this.props.users[0]['_id'];
        data['createdAt'] = new Date();
        data['updatedAt'] = new Date();
        contactsService.create(data).then(res => {
          localStorage.setItem('contactId', res._id);
          window.location.href = `/contact/${res._id}`;
        });
      } else if (contactId) {
        data['user_id'] = this.props.users[0]['_id'];
        data['updatedAt'] = new Date();
        contactsService.update(contactId, data).then(res => {
          window.location.href = `/contact/${contactId}`;
        });
      }
    });
  }

  render() {
    return (
      <>
        <Container className="p-3">
          <InputGroup className="mb-3">
            <InputGroup.Text id="onlyfans-username">@</InputGroup.Text>
            <FormControl
              placeholder="OnlyFans username"
              aria-label="OnlyFans username"
              aria-describedby="onlyfans-username"
              onChange={(e) => {
                this.setState({
                  onlyfansUsername: e.target.value
                })
              }}
              value={this.state.onlyfansUsername}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="instagram-username">@</InputGroup.Text>
            <FormControl
              placeholder="Instagram username"
              aria-label="Instagram username"
              aria-describedby="instagram-username"
              onChange={(e) => {
                this.setState({
                  instagramUsername: e.target.value
                })
              }}
              value={this.state.instagramUsername}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="tiktok-username">@</InputGroup.Text>
            <FormControl
              placeholder="Tiktok username"
              aria-label="Tiktok username"
              aria-describedby="tiktok-username"
              onChange={(e) => {
                this.setState({
                  tiktokUsername: e.target.value
                })
              }}
              value={this.state.tiktokUsername}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="paypal-username">@</InputGroup.Text>
            <FormControl
              placeholder="Paypal username"
              aria-label="Paypal username"
              aria-describedby="paypal-username"
              onChange={(e) => {
                this.setState({
                  paypalUsername: e.target.value
                })
              }}
              value={this.state.paypalUsername}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="twitter-username">@</InputGroup.Text>
            <FormControl
              placeholder="Twitter username"
              aria-label="Twitter username"
              aria-describedby="twitter-username"
              onChange={(e) => {
                this.setState({
                  twitterUsername: e.target.value
                })
              }}
              value={this.state.twitterUsername}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="github-username">@</InputGroup.Text>
            <FormControl
              placeholder="Github username"
              aria-label="Github username"
              aria-describedby="github-username"
              onChange={(e) => {
                this.setState({
                  githubUsername: e.target.value
                })
              }}
              value={this.state.githubUsername}
            />
          </InputGroup>

          <div className="d-grid gap-2">
            <Button size="lg" onClick={(e) => this.saveChanges()}>Save</Button>
          </div>

          <hr />

          <Contact
            onlyfansUsername={this.state.onlyfansUsername}
            instagramUsername={this.state.instagramUsername}
            tiktokUsername={this.state.tiktokUsername}
            paypalUsername={this.state.paypalUsername}
            twitterUsername={this.state.twitterUsername}
            githubUsername={this.state.githubUsername}
          />
        </Container>
      </>
    );
  }
}

function Login(props) {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState();

  function updateField(cb) {
    return ev => {
      cb(ev.target.value);
    };
  }

  function login() {
    return client
      .authenticate({
        strategy: 'local',
        email,
        password,
      })
      .catch(err => setError(err));
  }

  function signup() {
    return client
      .service('users')
      .create({ email, password })
      .then(() => login());
  }

  return (
    <Container className="p-3">
      <div className="text-center">
        <h1>Log in or signup</h1>

        {
          error &&
          <Alert variant="danger">{error.message}</Alert>
        }
      </div>


      <Form>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control type="email" placeholder="Enter email" onChange={updateField(setEmail)} />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control type="password" placeholder="Password" onChange={updateField(setPassword)} />
        </Form.Group>
        <Button variant="primary" type="submit" onClick={(e) => {
          e.preventDefault();
          login();
        }}>
          Log in
        </Button>{' '}
        <Button variant="primary" type="submit" onClick={(e) => {
          e.preventDefault();
          signup();
        }}>
          Signup
        </Button>
      </Form>
    </Container>
  );
}

function App(props) {
  const title = 'Fact';

  const [login, setLogin] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    client.authenticate().catch(() => {
      setLogin(null);
    });

    client.on('authenticated', loginResult => {
      Promise.all([
        contactsService.find(),
        usersService.find(),
      ]).then(([contactPage, userPage]) => {
        const contactResult = contactPage.data;
        const userResult = userPage.data;

        setLogin(loginResult);
        setContacts(contactResult);
        setUsers(userResult);
      });
    });

    client.on('logout', () => {
      setLogin(null);
      setContacts([]);
      setUsers([]);
    });

    contactsService.on('created', contact =>
      setContacts(currentContacts => currentContacts.concat(contact))
    );

    usersService.on('created', user =>
      setUsers(currentUsers => currentUsers.concat(user))
    );
  }, []);

  if (login === undefined) {
    return (
      <Container className="p-3">
        <h1>Loading...</h1>
      </Container>
    );
  } else if (login && users.length) {
    return (
      <Router>
        <Navbar bg="light" expand="lg">
          <Container>
            <Navbar.Brand href="/">{title}</Navbar.Brand>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/contact">Contact</Nav.Link>
              </Nav>
            </Navbar.Collapse>
            <Navbar.Collapse className="justify-content-end">
              <Navbar.Text>
                <a href="#logout" onClick={() => client.logout()}>Sign Out</a>
              </Navbar.Text>
            </Navbar.Collapse>
            <Navbar.Toggle />
          </Container>
        </Navbar>

        <Switch>
          <Route path="/contact">
            <Contact contacts={contacts} users={users} />
          </Route>
          <Route path="/contact/:contactId">
            <Contact contacts={contacts} users={users} />
          </Route>
          <Route path="/">
            <Home contacts={contacts} users={users} />
          </Route>
        </Switch>
      </Router>
    );
  }

  return (
    <Router>
      <Navbar bg="light" expand="lg">
        <Container>
          <Navbar.Brand href="/">{title}</Navbar.Brand>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/">Home</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          {
            login &&
            <>
              <Navbar.Collapse className="justify-content-end">
                <Navbar.Text>
                  <a href="#logout" onClick={() => {
                    client.logout();
                    window.location.href = '/';
                  }}>Sign Out</a>
                </Navbar.Text>
              </Navbar.Collapse>
              <Navbar.Toggle />
            </>
          }
        </Container>
      </Navbar>

      <Switch>
        <Route path="/contact/:contactId">
          <Contact />
        </Route>
        <Route path="/">
          <Login />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
